<div class="row">
  <div class="columns small-12 medium-10 medium-offset-1">
    <div id="swagger-ui" class="swagger-ui-section"></div>
  </div>
</div>

